/**
 * AddStyleDialog — Modal "Añadir Nuevo Estilo"
 *
 * Extraído de App.js líneas 9597-9630 durante la Ola D del refactor 2026-02.
 * Mini-formulario para añadir un nuevo estilo musical a la biblioteca.
 */

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from './ui/dialog';
import { Input } from './ui/input';
import { Button } from './ui/button';

export const AddStyleDialog = ({
  isOpen,
  onOpenChange,
  newStyleName,
  setNewStyleName,
  onAdd,
}) => {
  const handleCancel = () => {
    onOpenChange(false);
    setNewStyleName('');
  };

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent
        className="w-[95vw] max-w-md bg-slate-900 text-slate-100 border-slate-700"
        data-testid="add-style-dialog"
      >
        <DialogHeader>
          <DialogTitle>Añadir Nuevo Estilo</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <Input
            placeholder="Nombre del estilo"
            value={newStyleName}
            onChange={(e) => setNewStyleName(e.target.value)}
            className="bg-slate-800 border-slate-700"
            data-testid="add-style-input"
          />
          <div className="flex gap-2 justify-end">
            <Button
              variant="outline"
              onClick={handleCancel}
              className="border-slate-600 hover:bg-slate-800"
              data-testid="add-style-cancel-btn"
            >
              Cancelar
            </Button>
            <Button
              onClick={onAdd}
              className="bg-purple-600 hover:bg-purple-700"
              disabled={!newStyleName.trim()}
              data-testid="add-style-submit-btn"
            >
              Añadir
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default AddStyleDialog;
